import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 1025 1024"
    {...props}
  >
    <path
      fill="#cdcdcd"
      d="M513.344 0a512 512 0 1 0 0 1024 512 512 0 0 0 0-1024zm226.048 674.624-54.528 56.896-171.52-164.928L341.952 731.52l-54.592-56.896L456.576 512 287.36 349.312l54.592-56.768 171.392 164.8 171.52-164.8 54.528 56.768L570.176 512l169.216 162.624z"
    />
  </svg>
);
export default SvgComponent;
